// NEW STYPEPARAMS METHOD
var OVERLAY_HOVER_ANIMATION = {
    NO_EFFECT: 'NO_EFFECT',
    FADE_IN: 'FADE_IN',
    EXPAND: 'EXPAND',
    SLIDE_UP: 'SLIDE_UP',
    SLIDE_RIGHT: 'SLIDE_RIGHT',
    SLIDE_DOWN: 'SLIDE_DOWN',
    SLIDE_LEFT: 'SLIDE_LEFT',
};
export default OVERLAY_HOVER_ANIMATION;
//# sourceMappingURL=behaviourParams_item_overlay_hoverAnimation.js.map